import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class LightThemeAPI extends BasicsClass {
    public apiUrls: any = new Map([
        // ['forbideenLightThemeAccount', {
        //     url: '/user/forbid',
        //     name: 'account-forbid',
        //     label: '账户封禁'
        // }],
        ['getLightThemeTableList', {
            url: '/admin/light/list',
            name: 'list',
            label: '列表'
        }],

        ['addLightTheme', {
            url: '/admin/light/add',
            name: 'add-light-theme',
            label: '添加灯光主题'
        }],

        ['editLightTheme', {
            url: '/admin/light/edit',
            name: 'edit-light-theme',
            label: '编辑灯光主题'
        }],

        ['delLightTheme', {
            url: '/admin/light/del',
            name: 'delete-light-theme',
            label: '删除灯光主题'
        }],

        ['pulishLightTheme', {
            url: '/admin/light/publish',
            name: 'publish-light-theme',
            label: '发布灯光主题'
        }]
        // ['getLightThemeDetail', {
        
        
        //     name: 'detail',
        //     label: '详情',
        //     // hidden: true
        // }]
    ])


    // // 灯光主题列表
    public getLightThemeTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getLightThemeTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // // 添加灯光主题
    public addLightTheme(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('addLightTheme').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // 编辑灯光主题
    public editLightTheme(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('editLightTheme').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // 删除灯光主题
    public delLightTheme(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('delLightTheme').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // 发布灯光主题
    public pulishLightTheme(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('pulishLightTheme').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }
}